import React, { useEffect } from "react";

import Introduction from "../../components/Introduction/Introduction";
import Item from "../../components/Item/Item";
import products from "../../data/products.json";
import Spacer from "../../components/Spacer/Spacer";

const Home = () => {
  useEffect(() => {
    document.title = "StudioMK";
  }, []);

  return (
    <div>
      <Spacer size="medium"></Spacer>
      <Introduction />

      <div>
        {products.map((product, index) => (
          // eslint-disable-next-line react/jsx-no-undef
          <React.Fragment key={product.id}>
            <Spacer size="medium" />
            <Item product={product} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Home;
